import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateShareEditableFieldsEnabledMutationVariables = Types.Exact<{
  shareId: Types.Scalars['ID']['input'];
  editableFieldsEnabled: Types.Scalars['Boolean']['input'];
}>;


export type UpdateShareEditableFieldsEnabledMutation = { __typename?: 'Mutation', updateShare?: { __typename?: 'UpdateSharePayload', share?: { __typename?: 'AdHocAssetsShare', id: string, editableFieldsEnabled?: boolean | null } | { __typename?: 'CollectionShare', id: string, editableFieldsEnabled?: boolean | null } | null } | null };


export const UpdateShareEditableFieldsEnabled = /*#__PURE__*/ gql`
    mutation UpdateShareEditableFieldsEnabled($shareId: ID!, $editableFieldsEnabled: Boolean!) {
  updateShare(
    input: {shareId: $shareId, settings: {editableFieldsEnabled: $editableFieldsEnabled}}
  ) {
    share {
      id
      editableFieldsEnabled
    }
  }
}
    ` as unknown as DocumentNode<UpdateShareEditableFieldsEnabledMutation, UpdateShareEditableFieldsEnabledMutationVariables>;

          

          export const useUpdateShareEditableFieldsEnabledMutation = (options?:MutationHookOptions<UpdateShareEditableFieldsEnabledMutation, UpdateShareEditableFieldsEnabledMutationVariables>) => useMutation(UpdateShareEditableFieldsEnabled, options);
          

          export type UpdateShareEditableFieldsEnabledMutationOptions = MutationHookOptions<UpdateShareEditableFieldsEnabledMutation, UpdateShareEditableFieldsEnabledMutationVariables>;

          

          export type UpdateShareEditableFieldsEnabledMutationResult = ReturnType<typeof useUpdateShareEditableFieldsEnabledMutation>[1];

          
